import React from "react";
import { Translatable } from "../models/Translatable";
import { translate } from "../models/utilities/translationUtilities";
import { useLanguage } from "./useLanguage";
import useRecall from "./useRecall";

export default function useTranslatable(translatable: Translatable, key: string): string {
    const [language] = useLanguage();
    const translated = React.useMemo(() => translate(translatable, key, language), [
        key,
        translatable,
        language,
    ]);
    return useRecall(translated);
}
